import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { MissionToStaffReportInput } from '../../lib/types/models/mission-to-staff/mission-to-staff.input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type UpdateMissionTrackingMissionToStaffInput = Partial<MissionToStaffReportInput> & {
  id: number
  missionToStaffId: number
}

export function updateMissionTrackingMissionToStaff({
  id,
  missionToStaffId,
  ...rest
}: UpdateMissionTrackingMissionToStaffInput) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.updateMissionToStaff.url, { id, missionToStaffId }))
    .patch<MissionToStaff, Partial<MissionToStaffReportInput>>(rest)
}
